import React, { useState } from 'react';
import { createRequest } from '../../../api/localIntelligence';
import { RequestRow } from '../RequestsWorklistPanel';
import { BTN_PRIMARY, EYEBROW } from '../liStyles';

// Book a table or a spot for a guest. The database writes the request and hands back
// the call script; the desk makes the call and records what happened. The time is the
// one the staff member picks here, sent as an exact moment.
const toLocalInput = (iso) => {
  const d = iso ? new Date(iso) : new Date();
  if (Number.isNaN(d.getTime())) return '';
  const pad = (n) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
};

const RequestForm = ({ clientId, place, defaultPartySize, defaultAt, onCreated, onRecord, onOpenPlace }) => {
  const [partySize, setPartySize] = useState(defaultPartySize || 2);
  const [when, setWhen] = useState(toLocalInput(defaultAt));
  const [note, setNote] = useState('');
  const [state, setState] = useState({ saving: false, error: null, request: null });

  const submit = async (e) => {
    e.preventDefault();
    if (!when) return;
    setState({ saving: true, error: null, request: null });
    try {
      const request = await createRequest(clientId, {
        entityId: place.entity_id,
        partySize: Number(partySize),
        at: new Date(when).toISOString(),
        note: note.trim() || null,
      });
      setState({ saving: false, error: null, request });
      if (onCreated) onCreated(request);
    } catch (err) {
      setState({ saving: false, error: err?.message || 'Could not create the request.', request: null });
    }
  };

  const record = async (requestId, outcome) => {
    const updated = await onRecord(requestId, outcome);
    if (updated) setState((s) => ({ ...s, request: updated }));
  };

  if (state.request) {
    return (
      <div className="space-y-3">
        <h3 className={EYEBROW}>Request created</h3>
        <div className="rounded-lg border border-gray-200 dark:border-gray-800">
          <RequestRow row={state.request} onRecord={record} onOpenPlace={onOpenPlace} />
        </div>
      </div>
    );
  }

  return (
    <form onSubmit={submit} className="space-y-4" aria-label={`Book ${place?.name || ''}`}>
      <p className="text-sm text-gray-600 dark:text-gray-300">
        Booking at <span className="font-semibold text-gray-900 dark:text-gray-100">{place?.name}</span>
      </p>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        <label className="flex flex-col gap-1 text-sm text-gray-600 dark:text-gray-300">
          Party size
          <input type="number" min={1} max={100} value={partySize} onChange={(e) => setPartySize(e.target.value)} className="h-9 rounded-lg border border-gray-300 dark:border-gray-700 bg-white dark:bg-gray-900 px-3 text-sm text-gray-900 dark:text-gray-100" />
        </label>
        <label className="flex flex-col gap-1 text-sm text-gray-600 dark:text-gray-300">
          When
          <input type="datetime-local" value={when} onChange={(e) => setWhen(e.target.value)} className="h-9 rounded-lg border border-gray-300 dark:border-gray-700 bg-white dark:bg-gray-900 px-3 text-sm text-gray-900 dark:text-gray-100" />
        </label>
      </div>
      <label className="flex flex-col gap-1 text-sm text-gray-600 dark:text-gray-300">
        Note (optional)
        <input type="text" value={note} onChange={(e) => setNote(e.target.value)} placeholder="High chair, patio, birthday…" className="h-9 rounded-lg border border-gray-300 dark:border-gray-700 bg-white dark:bg-gray-900 px-3 text-sm text-gray-900 dark:text-gray-100 placeholder-gray-400" />
      </label>
      {state.error && <p className="text-sm text-red-600 dark:text-red-400" role="alert">{state.error}</p>}
      <button type="submit" className={BTN_PRIMARY} disabled={state.saving || !when}>
        {state.saving ? 'Creating…' : 'Create request'}
      </button>
    </form>
  );
};

export default RequestForm;
